import script from "./QueueTableRow.vue?vue&type=script&setup=true&lang=js"
export * from "./QueueTableRow.vue?vue&type=script&setup=true&lang=js"

import "./QueueTableRow.vue?vue&type=style&index=0&id=51eae6a2&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51eae6a2"]])

export default __exports__